import { DELIVERY_CARD_ASSET_URLS } from '../screens/delivery_list_screen/delivery_card/deliveryCardAssets';
import failedBackgroundImg from '../screens/delivery_list_screen/failed_delivery/background.png';
import failedTextImg from '../screens/delivery_list_screen/failed_delivery/failed_text.png';
import listHeaderTextImg from '../screens/delivery_list_screen/content/header_text.png';
import infoTitleTextSvg from '../screens/delivery_list_screen/info_popup/title_text.svg';
import infoBodyTextSvg from '../screens/delivery_list_screen/info_popup/body_text.svg';
import ratingTextImg from '../screens/delivery_list_screen/delivery_rating/rating_text.png';
import ratingValueBackgroundImg from '../screens/delivery_list_screen/delivery_rating/rating_value_background.png';
import ratingValueTextSvg from '../screens/delivery_list_screen/delivery_rating/rating_value_text.svg';
import infoIconImg from '../screens/components/atomic/buttons/info_popup_button/info_icon.png';
import infoPopupFrameImg from '../screens/components/atomic/dialog/info_popup_frame_2/info_popup_frame.png';
import againBackgroundImg from '../screens/delivery_list_screen/again-screen/background.png';
import againButtonYesImg from '../screens/delivery_list_screen/again-screen/button_yes.png';
import againButtonNoImg from '../screens/delivery_list_screen/again-screen/button_no.png';
import ticketImg from '../screens/components/atomic/icons/ticket/ticket.png';
import { DELIVERY_ITEM_IMAGES } from '../screens/components/atomic/delivery_items/deliveryItemImages';

export function getDeliveryListAssetUrls(): string[] {
  return [
    ...DELIVERY_CARD_ASSET_URLS,
    failedBackgroundImg,
    failedTextImg,
    listHeaderTextImg,
    infoTitleTextSvg,
    infoBodyTextSvg,
    ratingTextImg,
    ratingValueBackgroundImg,
    ratingValueTextSvg,
    infoIconImg,
    infoPopupFrameImg,
    againBackgroundImg,
    againButtonYesImg,
    againButtonNoImg,
    ticketImg,
    ...Object.values(DELIVERY_ITEM_IMAGES),
  ];
}
